"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecruitmentSearchListResponseSchema = exports.RecruitmentSearchListResultSchema = exports.RecruitmentSearchItemSchema = void 0;
/* eslint-disable perfectionist/sort-objects */
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
const RecruitmentStatSchema = zod_1.z.object({
    sent: schemas_1.PositiveIntegerSchema,
    opened: schemas_1.PositiveIntegerSchema,
    viewed: schemas_1.PositiveIntegerSchema,
    applications: schemas_1.PositiveIntegerSchema,
    interested: schemas_1.PositiveIntegerSchema,
});
exports.RecruitmentSearchItemSchema = zod_1.z.object({
    id: schemas_1.UUIDSchema,
    title: zod_1.z.string(),
    status: zod_1.z.string(),
    stats: RecruitmentStatSchema,
    createdAt: schemas_1.ISODateSchema,
    updatedAt: schemas_1.ISODateSchema,
});
exports.RecruitmentSearchListResultSchema = zod_1.z
    .object({ recruitment: exports.RecruitmentSearchItemSchema.array() })
    .extend(schemas_1.PaginationResponseSchema.shape);
exports.RecruitmentSearchListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.RecruitmentSearchListResultSchema);
